import React from 'react';
import SelectroV2 from '@aha-app/selectro-v2';
import { TemplateTypes, type TemplateType } from './AiTemplateController';

const TemplateTypeSelector: React.FC<{
  selectedType: TemplateType;
  onTypeChange: (type: TemplateType) => void;
}> = ({ selectedType, onTypeChange }) => {
  const typeLabels: Record<TemplateType, string> = {
    ALL: 'All',
    PROMPT: 'Requests',
    INSTRUCTION: 'Instructions',
    AGENT: 'Agents',
  };

  // Convert TemplateTypes to selectro items format
  const items = Object.entries(TemplateTypes).map(([key, value]) => ({
    value: value as TemplateType,
    text: typeLabels[value as TemplateType],
  }));

  // Set the currently selected item
  const selected = [
    {
      value: selectedType,
      text: typeLabels[selectedType],
    },
  ];

  return (
    <SelectroV2
      matchTriggerWidth
      type='single'
      items={items}
      selected={selected}
      hideSearchBar
      callbacks={{
        select: ({ payload }) => {
          onTypeChange(payload.item.value as TemplateType);
        },
      }}
    />
  );
};

export default TemplateTypeSelector;
